<template lang="pug">
  .resident-group-table-component
    // テーブル
    b-table(
      :items="_value"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :busy="isLoading"
      sticky-header
      no-border-collapse
      table-class="basic-table"
      show-empty
    )
      // ローディング
      template(#table-busy)
        .text-center.table-loading-message
          b-spinner.spinner
          span.message.align-self-center 読込み中...
      // レコード無し
      template(#empty)
        .empty-message
          span 情報がありません
      // フィルター後レコード無し
      template(#emptyfiltered)
        .empty-message
          span 情報がありません

      // セル：登録情報
      template(#cell(operation)="row")
        .center(v-if="row.item.id != 1")
          button.btn.edit-btn.disable(v-if="getRole == 2" type="button" disabled) 修正
          button.btn.edit-btn(v-else @click="onEdit(row.item)" type="button") 修正
          button.btn.delete-btn.disable(v-if="row.item.memberCount == undefined || 0 < row.item.memberCount || getRole == 2"
            @click="onDelete(row.item)" type="button" disabled) 削除
          button.btn.delete-btn(v-else @click="onDelete(row.item)" type="button") 削除
        .center(v-else)
          button.btn.edit-btn.disable(type="button" disabled) 修正
          button.btn.delete-btn.disable(type="button" disabled) 削除
      // セル：所属利用者
      template(#cell(members)="row")
        .d-flex.flex-row.justify-content-center.align-items-center
          .members-count
            b-spinner.spinner(v-if="row.item.memberCount == undefined")
            span(v-else) {{ row.item.memberCount }} 人
          .members-detail(v-if="0 < row.item.memberCount && getRole == 2")
            button.btn.list-btn(@click="onList(row.item)" type="button") 一覧
            button.btn.edit-btn.disable(type="button" disabled) 変更
          .members-detail(v-else-if="getRole == 2")
            button.btn.list-btn.disable(type="button" disabled) 一覧
            button.btn.edit-btn.disable(type="button" disabled) 変更
          .members-detail(v-else-if="row.item.memberCount == undefined || row.item.memberCount == 0")
            button.btn.list-btn.disable(type="button" disabled) 一覧
            button.btn.edit-btn(@click="onMemberEdit(row.item)" type="button") 変更
          .members-detail(v-else)
            button.btn.list-btn(@click="onList(row.item)" type="button") 一覧
            button.btn.edit-btn(@click="onMemberEdit(row.item)" type="button") 変更
</template>

<script lang="ts">
import { userStore } from "@/store/store";
import { Role } from "@/commons/services/Authorization";
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * 利用者グループテーブルコンポーネント
 */
@Component({})
export default class ResidentGroupTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<ResidentGroupTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<ResidentGroupTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;

  get _value(): Array<ResidentGroupTableItem> {
    return this.value;
  }

  /**
   * ### 修正ボタン押下イベント
   */
  public onEdit(group: ResidentGroupTableItem): void {
    this.$emit("onEdit", group);
    return;
  }

  /**
   * ### 削除ボタン押下イベント
   */
  public onDelete(group: ResidentGroupTableItem): void {
    this.$emit("onDelete", group);
    return;
  }

  /**
   * ### 一覧ボタン押下イベント
   */
  public onList(group: ResidentGroupTableItem): void {
    this.$emit("onList", group);
    return;
  }

  /**
   * ### 変更ボタン押下イベント
   */
  public onMemberEdit(group: ResidentGroupTableItem): void {
    this.$emit("onMemberEdit", group);
    return;
  }

  /** 権限ロールを返却する */
  get getRole(): Role {
    return userStore.loginUser.role;
  }
}

/** テーブルの列名の情報 */
export interface ResidentGroupTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface ResidentGroupTableItem {
  id: number;
  name: string;
  memberCount?: number;
  updated: number;
}
</script>

<style lang="scss" scoped>
.resident-group-table-component {
  .edit-btn,
  .delete-btn,
  .list-btn {
    width: 64px;
  }
  .operation {
    .edit-btn {
      margin-right: 12px;
    }
  }
  .list-btn {
    margin-right: 12px;
  }
}
</style>
